<div class="sg-flex-column sg-toaster-container"><ng-container #toastersVCRef></ng-container></div>
<ng-template #defaultToaster let-item let-ref="ref" let-index="index">
  <div
    [@detailExpand]="''"
    (mouseenter)="ref.disableTimeout()"
    (mouseleave)="ref.dismissAfterMouseLeave()"
    class="sg-flex-auto sg-flex-row-wrap sg-toaster sg-toaster-{{item.type}}">
    @if (item.showClose) {
    <a class="sg-toager-close-button" (click)="ref.close()"><mat-icon>close</mat-icon></a>
    }
    <div class="sg-flex-auto sg-flex-row sg-justify-start sg-items-center">
      <div class="sg-flex-auto sg-toaster-icon-container">
        @if (item.type !== 'wait') {
        <mat-icon>{{ item.content.icon }}</mat-icon>
        } @if (item.type === 'wait') {
        <div class="sg-full-height sg-justify-center sg-items-center"><mat-spinner diameter="24"></mat-spinner></div>
        }
      </div>
      <p class="sg-toaster-message-container">{{item.content.message}}</p>
    </div>
    <mat-progress-bar
      ngEvents
      (ngAfterInitAsync)="startLoop()"
      class="sg-toaster-progress-container"
      mode="determinate"
      [value]="item.progress"></mat-progress-bar>
  </div>
</ng-template>
